<template>
  <div>
    <div class="download-app" v-if="url">
      <a href="javascript:" class="text-dark text-decoration-none">
        <div class="container-fluid p-0">
          <div class="row no-gutters">
            <div class="col-9 d-flex align-items-center" @click="instalar()">
              <div class="download-app__img mr-2">
                <img :src="base_assets + '/favicons/android-icon-192x192.png'" alt="Logo da empresa">
              </div>
              <div>
                <h6 class="font-weight-normal mb-0">Baixe nosso App</h6>
                <div class="small"><b class="text-primary">Instalar agora</b> </div>
              </div>
            </div>
            <div class="col-3 text-right">
              <button class="btn" @click.prevent="close()">
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path d="M27.1 1.1c-10.4 2-19.4 9.1-23.9 18.7C1 24.5.5 26.9.5 33.5c0 15.5-6.8 7.8 107.5 122l101 101-101.9 102C24.4 441.4 4.9 461.4 3 465.5c-3.4 7.1-3.5 19.9-.2 27 2.9 6.3 9.3 12.9 15.7 16.3 7.2 3.7 18.7 4.2 27 1.2 5.8-2.2 9.4-5.6 108.3-104.4L256 303.5l101.8 101.6c81.7 81.6 102.7 102.1 106.7 104 4.2 2 6.5 2.4 14.5 2.4 8.3 0 10.1-.4 14.5-2.7 6.2-3.2 12.9-10.3 15.8-16.6 3.2-6.8 3-19.7-.3-26.7-1.9-4.1-21.4-24.1-104.1-107L303 256.5l101-101C518.3 41.3 511.5 49 511.5 33.5c0-6.5-.5-9-2.6-13.5-8.1-17.2-28.4-24.2-45.4-15.8-2.6 1.3-39.1 37-105.7 103.6L256 209.5 154.3 107.8C87.6 41.2 51.1 5.5 48.5 4.2 45.1 2.5 34-.3 32.1.1c-.3.1-2.6.5-5 1"/></svg>
              </button>
            </div>
          </div>
        </div>
      </a>
    </div>
    <modal-bottom :opened="modalDownload" v-if="modalDownload">
      <div class="container-fluid">
        <button class="btn btn-sm btn-close" @click="close()">
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512"><path d="M27.1 1.1c-10.4 2-19.4 9.1-23.9 18.7C1 24.5.5 26.9.5 33.5c0 15.5-6.8 7.8 107.5 122l101 101-101.9 102C24.4 441.4 4.9 461.4 3 465.5c-3.4 7.1-3.5 19.9-.2 27 2.9 6.3 9.3 12.9 15.7 16.3 7.2 3.7 18.7 4.2 27 1.2 5.8-2.2 9.4-5.6 108.3-104.4L256 303.5l101.8 101.6c81.7 81.6 102.7 102.1 106.7 104 4.2 2 6.5 2.4 14.5 2.4 8.3 0 10.1-.4 14.5-2.7 6.2-3.2 12.9-10.3 15.8-16.6 3.2-6.8 3-19.7-.3-26.7-1.9-4.1-21.4-24.1-104.1-107L303 256.5l101-101C518.3 41.3 511.5 49 511.5 33.5c0-6.5-.5-9-2.6-13.5-8.1-17.2-28.4-24.2-45.4-15.8-2.6 1.3-39.1 37-105.7 103.6L256 209.5 154.3 107.8C87.6 41.2 51.1 5.5 48.5 4.2 45.1 2.5 34-.3 32.1.1c-.3.1-2.6.5-5 1"/></svg>
        </button>
        <div class="download-app__img mx-auto mt-2" style="width: 72px; margin-bottom: 24px">
          <img :src="base_assets + '/favicons/android-icon-192x192.png'" alt="Logo da empresa">
        </div>
        <p>
          Instale o App e garanta ainda mais rapidez no seu próximo pedido.
        </p>
        <div v-if="isIOS">
          <p class="ios-app">
            Clique em
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#477FF1" viewBox="0 0 1024 1024"><path d="M443 183.5 374.5 252l14 14c7.7 7.7 14.2 14 14.5 14s20.1-19.6 44-43.5 43.8-43.5 44.2-43.5c.5 0 .8 85.5.8 190v190h40l.2-190.1.3-190.1 43.9 43.4c24.1 23.8 44.1 43.4 44.5 43.6.3.1 6.9-6.1 14.6-13.8l14-14-68.5-68.5c-37.7-37.7-68.7-68.5-69-68.5s-31.3 30.8-69 68.5"/><path d="M291.9 329.5c-21.9 5.3-39.2 22.8-44.4 44.7-2.2 9.5-2.2 389.1 0 398.6 4.8 20.5 19.9 36.4 41.5 43.8 5.3 1.8 12.4 1.9 223 1.9s217.7-.1 223-1.9c21.9-7.5 35.9-22.5 41.5-44.2 1.3-5.4 1.5-28.3 1.3-201.5-.3-187.6-.4-195.6-2.2-200.4-7.4-20-19.5-32.7-37.6-39.3l-7.5-2.7-78.8-.3-78.7-.3.2 20.3.3 20.3 75.5.5c84.9.6 79.3 0 84.8 8.2l2.7 4.2v384.2l-2.7 4.1c-1.6 2.4-4.4 4.9-7 6.2l-4.4 2.1H301.6l-4.4-2.1c-2.6-1.3-5.4-3.8-7-6.2l-2.7-4.1-.3-190c-.2-129.9 0-191.2.8-193.7 1.3-4.6 4.3-8.5 8.3-10.7 2.9-1.6 9.6-1.7 78.7-2.2l75.5-.5.3-20.3.2-20.2-76.7.1c-61 0-77.9.3-82.4 1.4"/></svg>
            e depois em <b>“Adicionar à Tela de Início”.</b>
          </p>
          <div class="text-center mt-4">
            <img src="../assets/arrow.png" alt="Seta" style="width: 42px">
          </div>
        </div>
        <div v-else>
          Clique nos três pontinhos do canto superior direito e depois em <b>“Adicionar à tela inicial”.</b>
          <button class="btn btn-block mt-3 text-primary" @click="close()">Agora não</button>
        </div>
      </div>
    </modal-bottom>
  </div>
</template>

<script>
  import ModalBottom from "./ModalBottom";
  export default {
    name: "DownloadApp",
    components: {ModalBottom},
    data() {
      return {
        url: null,
        app_ios: false,
        app_android: false,
        modalDownload: false
      }
    },

    methods: {
      close() {
        this.url = null;
        sessionStorage.setItem('closeApp', '1');
        document.body.classList.remove("modal-open");
        this.modalDownload = false;
      },

      instalar() {
        const url = this.url;
        this.url = null;

        if (url === 'pwa') {
          if (this.isAndroid && this.prompt) {
            this.prompt.prompt();

          } else {
            document.body.classList.add("modal-open");
            this.modalDownload = true;
          }

        } else if (url) {
          window.open(url, '_blank');
        }
      }
    },

    mounted() {
      if (sessionStorage.getItem('closeApp')) {
        return;
      }

      if (this.ios_installed || this.android_installed) {
        return;
      }

      if (window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
        return;
      }

      if (this.isIOS && process.env.VUE_APP_IOS_APP) {
        this.url = 'https://apps.apple.com/br/app/' + process.env.VUE_APP_IOS_APP;

      } else if (this.isAndroid && process.env.VUE_APP_ANDROID && process.env.VUE_APP_ANDROID_PACKAGE_NAME) {
        this.url = 'https://play.google.com/store/apps/details?id=' + process.env.VUE_APP_ANDROID_PACKAGE_NAME;

      } else if (this.isIOS || (this.isAndroid && this.prompt)) {
        this.url = 'pwa';
      }
    },

    computed: {
      prompt() {
        return this.$store.state.pwaPrompt;
      }
    }
  }
</script>

<style scoped>
  .download-app {
    padding: 15px 8px 15px 15px;
    background-color: #ffffff;
  }

  .download-app__img {
    width: 40px;
  }

  .download-app__img img {
    width: 100%;
    border-radius: 4px;
  }

  .btn-close {
    position: absolute;
    right: 15px;
  }

  @media (min-width: 768px) {
    .download-app {
      margin: 0 15px 8px;
      border-radius: 18px;
      box-shadow: var(--shadow);
    }
  }
</style>
